import { HttpQuery } from "@/interfaces/httpQuery";
import { Location } from "@/interfaces/location";
import {
  PmpConfig,
  PmpConfigForLocations,
  PmpHistoryLogs
} from "@/interfaces/pmp";
import HttpService from "./http.service";
import { messagesService } from "./messages.service";

class PmpService extends HttpService {
  public async getLocationsForPmpConfig(
    query?: HttpQuery
  ): Promise<PmpConfigForLocations[]> {
    try {
      this.query.embed = "user,state";
      this.uri = "/locations";
      const response = await super.get(query);
      return response.data.data;
    } catch (error) {
      return [];
    }
  }

  public async getPmpFtpConfig(query: HttpQuery = {}): Promise<PmpConfig[]> {
    try {
      this.uri =
        process.env.VUE_APP_BASE_URL_DISPENSARY +
        "/integrations/pmp_ftp_configs";
      const response = await this.axios({
        method: "GET",
        url: this.uri,
        params: query
      });
      return response.data.data.data;
    } catch (error) {
      return [];
    }
  }

  public async getPharmacyMode(locationId: number) {
    try {
      this.uri =
        process.env.VUE_APP_BASE_URL_DISPENSARY +
        "/setting/pharmacy_mode/" +
        locationId;

      const response = await this.axios({
        method: "GET",
        url: this.uri
      });
      return {
        id: response.data.data[0].id,
        status: response.data.data[0].pharmacy_mode_enabled
      };
    } catch (error) {
      return {
        id: null,
        status: null
      };
      messagesService.renderErrorMessage(error);
    }
  }
  public async enablePMPIntegration(
    locationId: number | null,
    pharmacyModeStatus: {
      pharmacy_mode_enabled: Boolean;
    }
  ) {
    try {
      this.uri =
        process.env.VUE_APP_BASE_URL_DISPENSARY +
        "/setting/pharmacy_mode/" +
        locationId;

      const response = await this.axios({
        method: "PUT",
        url: this.uri,
        data: pharmacyModeStatus
      });
      return response.data.status;
    } catch (error) {
      messagesService.renderErrorMessage(error);
    }
  }

  public async getCurrentPmpFtpConfig(
    location?: number[]
  ): Promise<PmpConfig[]> {
    try {
      this.uri =
        process.env.VUE_APP_BASE_URL_DISPENSARY +
        "/integrations/pmp_ftp_configs";
      const response = await super.get({ location_id: location });
      return response.data.data;
    } catch (error) {
      return [];
    }
  }

  public async getHistoryPmpFtpConfig(
    query: HttpQuery = {}
  ): Promise<PmpHistoryLogs[]> {
    try {
      this.uri =
        process.env.VUE_APP_BASE_URL_DISPENSARY +
        "/integrations/pmp_ftp_configs/logs";
      const response = await super.get(query);
      return response.data.data;
    } catch (error) {
      return [];
    }
  }

  public async setPmpFtpConfig(pmpConfig: PmpConfig, location: Location) {
    try {
      const response = await this.axios.request({
        url:
          process.env.VUE_APP_BASE_URL_DISPENSARY +
          "/integrations/pmp_ftp_configs",
        method: "POST",
        data: {
          status: +pmpConfig.status,
          location_id: location.id,
          host_name: pmpConfig.host_name,
          user_name: pmpConfig.user_name,
          password: pmpConfig.password,
          directory: pmpConfig.directory,
          port: pmpConfig.port,
          pmp_driver: pmpConfig.pmp_driver,
          pmp_auto_submission_interval: pmpConfig.pmp_auto_submission_interval
        }
      });
      return response.data;
    } catch (error) {
      return error.name;
    }
  }

  public async updatePmpFtpConfig(pmpConfig: PmpConfig, id?: number) {
    try {
      const response = await this.axios.request({
        url:
          process.env.VUE_APP_BASE_URL_DISPENSARY +
          "/integrations/pmp_ftp_configs/" +
          id,
        method: "PUT",
        data: {
          status: +pmpConfig.status,
          host_name: pmpConfig.host_name,
          user_name: pmpConfig.user_name,
          password: pmpConfig.password,
          directory: pmpConfig.directory,
          port: pmpConfig.port,
          pmp_driver: pmpConfig.pmp_driver,
          pmp_auto_submission_interval: pmpConfig.pmp_auto_submission_interval
        }
      });
      return response.data;
    } catch (error) {
      return error.name;
    }
  }
}

export const pmpService = new PmpService();
